import { Box, Typography } from '@mui/material';
import React from 'react';
import { dimGrey } from '../../../mainTheme';

interface CustomLegendProps {
  payload?: Array<{
    color?: string;
    name?: string;
    value?: number | string;
  }>;
  // Row spacing in theme units; five-row legends need 0 to fit the card.
  gap?: number;
}

export const CustomLegend = ({ payload, gap = 0.5 }: CustomLegendProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        fontSize: '0.75rem',
      }}
    >
      {payload?.map((entry, index) => (
        <Box
          key={`legend-${index}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: entry?.color,
            }}
          />
          <Typography
            sx={{
              color: dimGrey,
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '16px',
            }}
          >
            {entry?.value} {entry?.name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
